export default "__VITE_ASSET__651b69cc__"